<template>
   <div class="mainbody" style="min-height: 40vw;">
    <div class="thirdLine" v-scroll-animate="'slide-itemgk'">
            <!-- <span class="line"></span> -->
            <div class="txt">
              <span>产业布局</span>
            </div>
            <!-- <span class="line"></span> -->
      </div> 

	 

	<div class="containerDiv"> 
		<div class="whiteBg" v-scroll-animate="'fly-in-left5'"> 
			<div class="modules0" style="text-align: center;">
				<div class="title-with-lines">
					<div class="clipped-gradient-line clipped-gradient-line1"></div>
					<span class="title-text"><span>"<b>1</b>"个核心功能板块</span></span>
					<div class="clipped-gradient-line"></div>
				</div>
			</div>
			<div class="modules1 modules9" @mouseover="indexNum = 20"
                             @mouseleave="indexNum = null"
                            :class="(indexNum == 20)?'activeModules2Item':''" @click="goXiandaiwuliu('现代物流')">
				<h5>现代物流</h5>
				<p>
					以河南中豫物流集团有限公司为主体，功能定位现代物流运营主体，整合以物流业务为主营业务的所属公司。主要业务包括海、陆、空货源组织开发，全程物流服务，陆空联运等多式联运产品和服务。
				</p>
			</div>
	
		</div>

		<div class="whiteBg" v-scroll-animate="'fly-in-right5'"> 
			<div class="modules0" style="text-align: center;">
				<div class="title-with-lines"  @click="goXiandaiwuliu('中欧班列')">
					<div class="clipped-gradient-line clipped-gradient-line1" ></div>
					<span class="title-text"><span>"<b>2</b>"个核心功能支撑板块</span></span>
					<div class="clipped-gradient-line"></div>
				</div>
			</div>
	
			<div class="modules1 modules2"  @click="goXiandaiwuliu('中欧班列')">
			
				<div class="modules2div1" @mouseover="indexNum = 10"
                             @mouseleave="indexNum = null"
                            :class="(indexNum == 10)?'activeModules2Item':''">
					<h5>郑州国际陆港（航空港片区）</h5>
					<p  >以河南国际物流枢纽建设运营有限公司为主体，作为国际班列业务保障平台，功能定位为陆港资产持有者和运营者，负责港区运营管理、项目合作开发，主要承担班列集结、大宗商品交易、新能源汽车物流等职能，打造中欧班列运贸产创新发展联动区。</p>
				</div>
				<div class="centerLine" >
					<div class="vertical-clip-line" ></div>
				</div>
				<div @mouseover="indexNum = 11"
                             @mouseleave="indexNum = null"
                            :class="(indexNum == 11)?'activeModules2Item':''">
					<h5>郑州国际陆港（经开片区）</h5>
					<p  >以郑州国际陆港开发建设有限公司为主体，作为国际班列业务保障平台，功能定位为陆港资产持有者和运营者，着重培育新动能产业集群，围绕班列贸易、商品展销、总部经济等业态，打造中欧班列特色商贸区。</p>
				</div>
				
			</div>
		</div>

		<div class="modules3Div" v-scroll-animate="'fly-in-left5'"> 
			<div class="modules0" style="text-align: center;">
				<div class="title-with-lines">
					<div class="clipped-gradient-line clipped-gradient-line1"></div>
					<span class="title-text"><span>"<b>5</b>"个核心业务板块</span></span>
					<div class="clipped-gradient-line"></div>
				</div>
			</div>
	
			<div class="modules3rowDiv" style="display: flex;gap: 1rem;" @click="goXiandaiwuliu('港贸')">
				<div class="modules3Item modules3Item1" style="flex: 20%;height:22rem;"  @mouseover="indexNum = 1"
                             @mouseleave="indexNum = null"
                            :class="(indexNum == 1)?'activeModules3Item':''">
					<ul>
						<li>
							<img src="../../assets/img3/gaikuang1/a4.png" />
						</li>
						<li class="titleModule3item">
							商贸服务 
						</li>
						<li class="txtModule3item">
							以河南港贸商业服务有限公司为主体，功能定位为商品供应链服务，整合集团商品贸易业务，包括以贸易为主营业务的所属公司及代管企业。
						</li>
					</ul>
				</div>

				<div class="modules3Item modules3Item1" style="flex: 20%;height:22rem;" @mouseover="indexNum = 2"
                             @mouseleave="indexNum = null"
                            :class="(indexNum == 2)?'activeModules3Item':''"
							@click="goXiandaiwuliu('港产')">
					<ul>
						<li>
							<img src="../../assets/img3/gaikuang1/a5.png" />
						</li>
						<li class="titleModule3item">
							资产管理
						</li>
						<li class="txtModule3item">
							以河南港产运营管理有限公司为主体，功能定位资产管理。整合集团所属资产租赁业务，包括以资产租赁为主营业务的所属公司及代管企业。
						</li>
					</ul>
				</div>

				<div class="modules3Item modules3Item1" style="flex: 20%;height:22rem;" @mouseover="indexNum = 3"
                             @mouseleave="indexNum = null"
                            :class="(indexNum == 3)?'activeModules3Item':''"
							@click="goXiandaiwuliu('开发建设')">
					<ul>
						<li>
							<img src="../../assets/img3/gaikuang1/a1.png" />
						</li>
						<li class="titleModule3item">
							工程建设
						</li>
						<li class="txtModule3item">
							以河南中豫港航建设工程有限公司为主体，功能定位为陆港和临港产业的开发和建设。主要业务包括陆港项目、集团公司存量土地以及临港产业开发建设等。					</li>
					</ul>
				</div>

				<div class="modules3Item modules3Item1" style="flex: 20%;height:22rem;" @mouseover="indexNum = 4"
                             @mouseleave="indexNum = null"
                            :class="(indexNum == 4)?'activeModules3Item':''"
							@click="goXiandaiwuliu('科技板块')">
					<ul>
						<li>
							<img src="../../assets/img3/gaikuang1/a3.png" />
						</li>
						<li class="titleModule3item">
							科技创新
						</li>
						<li class="txtModule3item">
							以河南中浩信息科技有限公司为主，功能定位为科技赋能，推动集团公司提升科技创新能力，加快集团公司数字化转型，前瞻布局新兴产业等。
						</li>				
					</ul>
				</div>

				<div class="modules3Item modules3Item1" style="flex: 20%;height:22rem;"  @mouseover="indexNum = 5"
                             @mouseleave="indexNum = null"
                            :class="(indexNum == 5)?'activeModules3Item':''"
							@click="goXiandaiwuliu('投资金融')">
					<ul>
						<li>
							<img src="../../assets/img3/gaikuang1/a2.png" />
						</li>
						<li class="titleModule3item">
							投资金融
						</li>
						<li class="txtModule3item">
							以河南中豫港通资本投资有限公司为主体，整合基金公司，功能定位集团公司投融资平台，代表集团公司对外投资重大项目。
						</li>				
					</ul>
				</div>
			</div>
		</div>
	</div>
     
    
     
    </div>
</template>

<script>
// import Modules3 from '@/components/gk/Modules3.vue'

export default {
	components: {
	},
  data() {
    return {
		indexNum:null
     
      
    }
  },
  props: {
    
  },
  methods: {
    goXiandaiwuliu(explainsObj){
		if(explainsObj == '港贸'){
			this.$router.push({
				path: '/detailPage2'
			})
		}else if(explainsObj == '港产'){
			this.$router.push({
				path: '/detailPageGangchan'
			})
		}else{
			const encodedTitle = encodeURIComponent(explainsObj)
			this.$router.push({
				path: '/businessDetail',
				query: {                     
				title: encodedTitle,
				dingwei:'1'
				}
			})
		}
		
	}
  },
}
</script>

<style lang="scss" scoped>
 .modules1{
	color:#015293;
 }
 .modules3Item{
	color:#015293;
 }
  .modules3Item ul li img{
	 filter: sepia(1) saturate(3) hue-rotate(190deg);
 }
   .activeModules3Item ul li img{
	 filter: brightness(0) invert(1);
 }
  .activeModules3Item{
	color:#ffffff;
 }
  .mainbody{
    width: 100%;
    // background: #dde8f4;
    // margin-block: 100px;
    // background:url('../../assets/img3/gaikuang1/chanyepng.png');
	// background-size: 100% 100%;
	// .modules0{
	// 	width: 100%;
	// 	margin: 0 auto;
	// }
     
  }
  .containerDiv{
	width: 100%;
    // background: #dde8f4;
    // margin-block: 100px;
    // background:url('../../assets/img3/gaikuang1/chanyepng.png');
    background:url('../../assets/img/chanyebujuBg.png');
	background-size: 100% 100%;
	@media screen and (max-width: 768px) {
		background-size: auto 100%;
	}
  }

	.whiteBg{
		width: 90%;
		margin:0 auto;
		margin-bottom: 2rem;
		padding:2rem 0;
		background:linear-gradient(to bottom, rgba(252, 253, 253, 0), rgb(251, 252, 252,0.8))
	} 
	.modules3Div{
		width: 90%;
		margin:0 auto;
		padding:2rem 0;
	}
	.modules3rowDiv{
		display: flex;
	}
	</style>